import { saveSurface } from './functions'
import {
  activeButton, bringUserBackToStart, editableState, selectClick
} from './helperFunctions'
import { lowlightId } from './map/d3Renderer'
import { toggleTips } from './map/drawing'
import { map } from './map/tools'
import { hideFeatureInfo, showToolbar } from './navigation'
import { makeMessagebox, showMessageBox } from './notifications'
import { highlighted, i18n, minZoom } from './storage'

export const loadDesign = (gui) => {
  // console.log('Loading design according to configuration file');
  if (gui.toolbar) {
    document.getElementById('toolbar').hidden = false;
    document.getElementById('search_free').classList.remove('searchButtons_clicked');
    // document.getElementById('toolbarWindow').hidden = false;

    document.getElementById('spaceOnTop').style.marginTop = 0;
    const cc = document.getElementById('cardContainer');
    cc.style.width = 'calc(100% - ' + gui.toolbar.width + ')';
    cc.style.left = gui.toolbar.width;

    // Search defaults:
    const sf = document.getElementById('searchField');
    sf.style.background = '#F4F5F5';
    sf.style.borderColor = '#0A5990';
    sf.style.borderWidth ='2px';
    sf.style.heigth = '50px';
    const cf = document.getElementById('coordinatesField');
    cf.hidden = true;
    /*const cfh = document.getElementById('coordinatesFieldHeader');
    cfh.style.color = '#0A5990';
    cfh.classList.remove('blue-grey');
    cfh.classList.remove('darken-1');
    cfh.classList.add('white');

    document.getElementById('coordinatesFieldHeader').classList.add('active');*/
    document.getElementById('coordinatesFieldBody').style.display = 'block';

    const cfb = document.getElementById('coordinatesFieldBody');
    cfb.getElementsByTagName('label')[0].style.color = '#0A5990';
    cfb.getElementsByTagName('input')[0].style.color = '#0A5990';
    cfb.getElementsByTagName('label')[1].style.color = '#0A5990';
    cfb.getElementsByTagName('input')[1].style.color = '#0A5990';
    cfb.getElementsByTagName('label')[2].style.color = '#0A5990';
    cfb.getElementsByTagName('input')[2].style.color = '#0A5990';
    cfb.classList.remove('blue-grey');
    cfb.classList.remove('darken-1');
    cfb.classList.add('white');

    // GPS button:
    const gb = document.getElementById(gui.logistics.gpsButton.id);
    gb.style.background = '#0A5990';
    gb.classList.remove('white');
    //gb.classList.remove('teal');
    //gb.classList.add('light-blue');
    //gb.classList.add('darken-4');
    gb.getElementsByTagName('span')[0].className = 'white-text';
    // gb.firstElementChild.firstElementChild.className = 'white-text';
    document.getElementById(gui.logistics.gpsButton.location).appendChild(gb);

    // searchInfo div
    const infoDiv = document.createElement('div');
    infoDiv.id = 'searchInfo';
    document.getElementById('toolbarWindowSearch').appendChild(infoDiv);
    infoDiv.innerHTML = i18n['searchInfo']['freeSearchInfo'];

    // Tegn ny:
    const tb = document.getElementById('geometry-change');
    tb.innerHTML = '<i class="material-icons">create</i>';
    tb.className = 'tooltipped';
    const ti = document.getElementById('toolbar_info');
    const buttons = document.getElementById('toolbarButtons');
    buttons.insertBefore(tb, ti);
    const s1 = document.getElementById(gui.logistics.drawingInfo.id);
    document.getElementById(gui.logistics.drawingInfo.location).appendChild(s1);
    const s2 = document.getElementById(gui.logistics.drawingDateSelection.id);
    const l2 = gui.logistics.drawingDateSelection.location;
    document.getElementById(l2).appendChild(s2); // dateSelectionCard

    // Ask to select feature:
    const ats = document.getElementById(gui.logistics.askToSelect.id);
    ats.classList.remove('blue-grey', 'darken-1');
    ats.firstElementChild.classList.remove('white-text');
    document.getElementById(gui.logistics.askToSelect.location).appendChild(ats);

    // Endre:
    const eb = document.getElementById('geometry-change-attributes');
    eb.innerHTML = '<i class="material-icons">build</i>';
    eb.className = 'tooltipped';
    buttons.insertBefore(eb, ti);
    const eo = document.getElementById(gui.logistics.editingInfo.id);
    document.getElementById(gui.logistics.editingInfo.location).appendChild(eo);

    // Info box:
    const addTitleToCard = (title, card) => {
      const cardContent = card.getElementsByClassName('card-content')[0];
      cardContent.classList.remove('white-text');
      const t = document.createElement('span');
      t.id = card.id + 'Title';
      t.style.color = 'black';
      t.className = 'card-title';
      t.textContent = title;
      cardContent.appendChild(t);
      return cardContent;
    };
    const ib = document.getElementById(gui.logistics.featureInfo.id);
    ib.classList.remove('card-height', 'blue-grey', 'darken-1');
    const ibContent = addTitleToCard('Egenskaper for valgt flate', ib);
    document.getElementById(gui.logistics.featureInfo.location).appendChild(ib);
    infoCardTitle.hidden = true;
    const ibpt = document.getElementById('info-box-popup-text');
    ibpt.classList.remove('white-text');
    ibpt.innerHTML = '<p class="bb">' + i18n.surface.selectFeature + '</p>';
    ibContent.appendChild(ibpt);
    // Append hidden card-action with buttons:
    const infoCardAction = document.createElement('div');
    infoCardAction.id = 'infoCardAction';
    infoCardAction.className = 'card-action';
    infoCardAction.hidden = true;
    const icEdit = document.createElement('button');
    icEdit.className = 'btn small-button';
    icEdit.innerText = 'Endre';
    infoCardAction.appendChild(icEdit);
    const icClose = document.createElement('button');
    icClose.id = 'lukkBtn';
    icClose.className = 'btn small-button';
    icClose.style.marginLeft = '10px';
    icClose.innerHTML = 'Avbryt';
    icClose.title = 'Hurtigtast Esc';
    infoCardAction.appendChild(icClose);
    ib.appendChild(infoCardAction);

    // Just create message box:
    makeMessagebox();

    // Button interaction:
    ['search', 'info', 'help'].forEach(tab => {
      const toolbarButton = document.getElementById('toolbar_' + tab);
      toolbarButton.onclick = () => {
        if (activeButton(toolbarButton)) showToolbar(tab);
        else if (tab === 'info') editableState();
      };
    });
    // tb.onclick = () => { if (activeButton(tb)) showToolbar('draw'); };
    // eb.onclick = () => { if (activeButton(eb)) showToolbar('edit'); };
    icEdit.onclick = () => {
      hideFeatureInfo();
      // showEditOptions();
      document.getElementById('geometry-change-attributes').click();
    };
    icClose.onclick = () => {
      hideFeatureInfo();
      showToolbar('none');
      lowlightId(highlighted);
      bringUserBackToStart();
    };

    // Cards to hide:
    const hcc = document.createElement('div');
    hcc.id = 'hiddenCardsContainer';
    hcc.hidden = true;
    gui.hiddenCards.forEach(cardId => {
      // console.log(cardId);
      const c = document.getElementById(cardId);
      if (c) hcc.appendChild(c);
    });
    // document.body.appendChild(hcc); // not needed, they will disappear.

    // CSS changes in drawCards
    const dc =  document.getElementById('drawingCard');
    dc.style.background = '#FFF';
    dc.classList.remove('blue-grey');
    dc.classList.remove('darken-1');

    const dcContent = addTitleToCard('Tegner ny grense', dc);

    const a  = document.createElement('a');
    a.id = 'hideLink';
    a.onclick = toggleTips;
    a.style.cursor = 'pointer';
    a.innerText = 'Skjul tips';
    dcContent.appendChild(a);

    const ibtt = document.getElementById('info-box-text-text');
    ibtt.classList.remove('white-text');
    dcContent.appendChild(ibtt);
    dcContent.appendChild(document.getElementById('multiple'));

    const dsc = document.getElementById('dateSelectionCard');
    dsc.style.background = '#FFF';
    dsc.classList.remove('blue-grey');
    dsc.classList.remove('darken-1');

    const dscContent = addTitleToCard('Lagre grense', dsc);

    const sDiv = document.createElement('div');
    sDiv.id = 'sDiv_text';
    sDiv.innerHTML = i18n['surface']['save-border-text-ar5'].join('');

    const sDiv2 = document.createElement('div');
    sDiv2.id = 'sDiv2_text';
    sDiv2.innerHTML = i18n['surface']['save-border-text2-ar5'].join('');

    dscContent.appendChild(sDiv);
    const ibdar = document.getElementById('info-box-drawnline-attributes-row');
    dscContent.appendChild(ibdar);
    dsc.getElementsByClassName('card-action')[0].appendChild(sDiv2);

    // Editing card:
    const ec =  document.getElementById('editingCard');
    ec.style.background = '#FFF';
    ec.classList.remove('blue-grey');
    ec.classList.remove('darken-1');

    const ecContent = addTitleToCard('Endre egenskaper for valgt flate', ec);
    const iboar = document.getElementById('info-box-object-attributes-row');
    ecContent.appendChild(iboar);

    backButton.onclick = () => {
      tweStep3.hidden = true;
      tweStep2.hidden = false;
    };
    confirmButton.onclick = () => {
      tweStep3.hidden = true;
      tweStep1.hidden = false;
      // closeToolbarWindow();
      // Wrong/multiple when splitting polygons:
      saveSurface(selectClick.getFeatures().getArray());
      // Anytime selection or after-server-split selection:
      // saveSurface([selectedFeatureOl || globalSelectedFeature]);
      bringUserBackToStart();
      map.getView().setMinZoom(minZoom);
      // showMessageBox('updateMessage');
    };

    // Blue buttons:
    saveNewLineBtn.classList.remove('green', 'darken-1');
    regretNewLineBtn.classList.remove('red', 'darken-2');
    deleteLastDrawnPointBtn.classList.remove('orange', 'darken-3');
    regretButton.classList.remove('red', 'darken-2');
    doneButton.classList.remove('green', 'darken-1');

    // Unused buttons («logg ut», «hjelp»):
    document.getElementById('help3').hidden = true;
    document.getElementById('logout3').hidden = true;
    document.getElementById('help4').hidden = true;
    document.getElementById('logout4').hidden = true;

    // Start with open window:
    document.getElementById('toolbar_search').click();
    document.getElementById('search_free').classList.add('searchButtons_clicked');

    // Show welcome message after having clicked toolbar_search:
    showMessageBox('startupMessage');
  }
};
